<template>
	<div>
		<div class="bs-example">
			<template>
				<div class="lineone">
					<div class="select-option">
						<div class="label-name">{{ $t('billsReceivable.clientName') }}</div>
						<a-auto-complete
							:data-source="dataSourceCustomerName"
							v-model.trim="params.condition.customerName"
							size="small"
							:placeholder="$t('billsReceivable.clientName')"
							:allowClear="true"
							class="input-style"
							@select="onSelect"
							@change="onChangeinput"
						/>
					</div>
					<div class="select-option">
						<div class="label-name">{{ $t('billsReceivable.accountNumber') }}</div>
						<a-auto-complete
							v-model.trim="params.condition.number"
							:data-source="dataSourceNumber"
							size="small"
							:placeholder="$t('billsReceivable.accountNumber')"
							:allowClear="true"
							class="input-style"
							@select="onSelect"
							@change="onChangeinput"
						/>
					</div>
					<div class="select-option">
						<div class="label-name">{{ $t('billsReceivable.paymentStatus') }}</div>
						<a-select
							:placeholder="$t('billsReceivable.paymentStatus')"
							v-model.trim="params.condition.paymentStatus"
							:getPopupContainer="(triggerNode) => triggerNode.parentNode"
							:allowClear="true"
							class="input-style"
							size="small"
						>
							<a-select-option value="">
								{{ $t('all') }}
							</a-select-option>
							<a-select-option value="true">
								{{ $t('billsReceivable.paid') }}
							</a-select-option>
							<a-select-option value="false">
								{{ $t('billsReceivable.unpaid') }}
							</a-select-option>
						</a-select>
					</div>
					<div class="select-option">
						<div class="label-name">{{ $t('billsReceivable.invoicingStatus') }}</div>
						<a-select
							:placeholder="$t('billsReceivable.invoicingStatus')"
							v-model.trim="params.condition.billingStatus"
							:getPopupContainer="(triggerNode) => triggerNode.parentNode"
							:allowClear="true"
							class="input-style"
							size="small"
						>
							<a-select-option value="">
								{{ $t('all') }}
							</a-select-option>
							<a-select-option value="true">
								{{ $t('billsReceivable.invoiced') }}
							</a-select-option>
							<a-select-option value="false">
								{{ $t('billsReceivable.notInvoiced') }}
							</a-select-option>
						</a-select>
					</div>
					<div class="select-date">
						<div class="label-name">{{ $t('billsReceivable.billDate') }}</div>
						<a-form-item>
							<div class="input-form timepicker">
								<a-range-picker
									:locale="locale"
									:ranges="{
										[$t('today')]: [moment(), moment()],
										[$t('currentMonth')]: [moment(), moment().endOf('month')],
									}"
									@change="onChange"
									v-model="dateRange"
									:valueFormat="dateFormat"
									:format="monthFormat"
									dropdownClassName="dateRangeClass"
									:getCalendarContainer="
										(triggerNode) => triggerNode.parentNode
									"
									size="small"
									class="range-picker"
								/>
							</div>
						</a-form-item>
					</div>
				</div>
				<div class="linetwo">
					<div>
						<a-button
							style="margin-right: 10px;"
							type="primary"
							@click="search"
							size="small"
						>
							{{ $t('search') }}
						</a-button>
						<a-button size="small" @click="reset">{{ $t('reset') }}</a-button>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
// import dayjs from "dayjs";
// import { customerlist } from "../api/basicData";
import { queryBillingReportList } from "../../../api/receivable";
import { searchReqParam } from "../../../utils/searchReqParam";
var setDefaultSearch = function() {
	return {
		billingStatus: "",
		companyId: "",
		customerName: "", // 客户名称
		fromDate: "",
		// dayjs()
		// 	.startOf("month")
		// 	.subtract(2, "months")
		// 	.format("YYYY-MM-DD") + " 00:00:00", // 做箱时间(起),
		toDate: "",
		// dayjs()
		// 	.endOf("month")
		// 	.format("YYYY-MM-DD") + " 23:59:59", // 做箱时间(止),
		number: "",
		paymentStatus: "",
	};
};
export default {
	name: "searchForm",
	data() {
		return {
			req: searchReqParam(),
			params: {
				condition: setDefaultSearch(),
				page: 1, // 页码
				pageSize: 10, // 页容量
			},
			dateRange: [
				// dayjs()
				// 	.startOf("month")
				// 	.subtract(2, "months")
				// 	.format("YYYY-MM-DD"),
				// dayjs()
				// 	.endOf("month")
				// 	.format("YYYY-MM-DD"),
			],
			locale,
			dateFormat: "YYYY-MM-DD",
			monthFormat: "YYYY-MM-DD",
			dataSourceCustomerName: [],
			dataSourceNumber: [],
		};
	},
	watch: {
		dateRange: {
			handler() {
				let params = this.params.condition;
				if (this.dateRange && this.dateRange.length == 2) {
					params.fromDate = this.dateRange[0]
						? this.dateRange[0] + " 00:00:00"
						: "";
					params.toDate = this.dateRange[1]
						? this.dateRange[1] + " 23:59:59"
						: "";
				} else {
					params.fromDate = "";
					params.toDate = "";
				}
			},
			deep: true,
		},
	},
	created() {},
	mounted() {},
	methods: {
		moment,
		search() {
			this.req.params = this.params;
			console.log(this.req);
			this.$emit("search", this.req);
		},
		// 重置
		reset() {
			this.params.condition = setDefaultSearch();
			this.dateRange = [
				// dayjs()
				// 	.startOf("month")
				// 	.subtract(2, "months")
				// 	.format("YYYY-MM-DD"),
				// dayjs()
				// 	.endOf("month")
				// 	.format("YYYY-MM-DD"),
			];
		},

		// 监听日期筛选器的变动
		onChange() {
			console.log("== date change ==");
			this.activeItem = "";
		},
		handleChange(value) {
			console.log(`selected ${value}`);
		},
		onSelect(value) {
			console.log("onSelect", value);
		},
		// 输入框模糊查询
		onChangeinput(searchText) {
			this.req.params = this.params;

			queryBillingReportList(this.req)
				.then((res) => {
					let temp = JSON.parse(res.data).data.list;
					console.log(temp);
					// 提单
					this.dataSourceCustomerName = [];
					temp.forEach((item) => {
						if (this.dataSourceCustomerName.indexOf(item.customerName) == -1) {
							this.dataSourceCustomerName.push(item.customerName);
						}
						console.log(this.dataSourceCustomerName);
					});
					this.dataSourceCustomerName = !searchText
						? []
						: this.dataSourceCustomerName;

					// 账单号
					this.dataSourceNumber = [];
					temp.forEach((item) => {
						if (this.dataSourceNumber.indexOf(item.number) == -1) {
							this.dataSourceNumber.push(item.number);
						}
					});
					this.dataSourceNumber = !searchText ? [] : this.dataSourceNumber;
				})
				.catch((err) => {
					this.$message.error(err);
				});
		},
	},
};
</script>
<style lang="less" scoped>
.bs-example {
	width: 100%;
	height: 80px;
}
.lineone {
	width: 100%;
	height: 50%;
	display: flex;
	align-items: center;
	justify-content: left;
}
.linetwo {
	display: flex;
	height: 50%;
	align-items: center;
	justify-content: flex-end;
}
.select-option {
	width: 17%;
	display: flex;
	align-items: center;
	justify-content: left;
}
.label-name {
	width: 70px;
}
.input-style {
	width: 60%;
}
.select-date {
	width: 32%;
	display: flex;
	align-items: center;
	justify-content: left;
	/deep/.ant-form-item {
		margin-bottom: 0;
	}
}
</style>
